var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            inline: "",
            "label-position": "right",
            "label-width": "90px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-form-item",
                { attrs: { label: "图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        "on-exceed": _vm.handleExceed,
                        action: _vm.uploadUrl,
                        "on-preview": _vm.handlePreview,
                        limit: 3,
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess,
                        "before-upload": _vm.beforeUpload,
                        headers: _vm.importHeaders,
                        "file-list": _vm.fileList,
                        "show-file-list": true,
                        "list-type": "picture-card"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "paixu" },
                [
                  _vm._v(" 排序 "),
                  _vm._l(_vm.fileList, function(i, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: { display: "flex", "margin-left": "10px" }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { min: 0, max: _vm.fileList.length },
                          model: {
                            value: i.imgSort,
                            callback: function($$v) {
                              _vm.$set(i, "imgSort", $$v)
                            },
                            expression: "i.imgSort"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.handCancle }
            },
            [_vm._v(_vm._s(_vm.$t("button.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isBtnDisable },
              on: { click: _vm.handCreate }
            },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.dialogPreVisible,
            width: "500px",
            title: "图片预览"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogPreVisible = $event
            }
          }
        },
        [
          _c("div", { ref: "picPreview", attrs: { id: "picPreview" } }, [
            _c("img", { attrs: { src: _vm.picUrl, width: "460px" } })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }